import { createSlice } from '@reduxjs/toolkit'
import { loginThunk } from './authThunks'

const initialState = {
  user: null,
  //   token: null,
  subscriptions: null,
  loading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loginThunk.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(loginThunk.fulfilled, (state, action) => {
      state.loading = false
      state.user = action.payload?.user ?? null
      state.subscriptions = action.payload?.user?.subscriptions.find(s => s.status === 'ACTIVE') ?? []
    })
    builder.addCase(loginThunk.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  },
})

export default authSlice.reducer
